// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home_Backgroundhome__8LZQz {
    width: 100%; 
    height: 100%;
  }

.Home_BoxBlack__bjOBn {
box-shadow: 3px 3px 1px 1px #fff;
box-shadow: 2px 2px 6px 2px #fff;
box-shadow: 7px 7px 5px -5px #c1f1f7;
box-shadow: 0px 0px 5px 3px #fff;
/* box-shadow: 4px 4px 4px 4px #c1f1f7; */
/* box-shadow: 8px 6px 5px -5px #c1f1f7;  */
box-shadow: 0px 0px 3px 3px #fff;
box-shadow: 2px 2px 6px #fff;
transition-timing-function: ease;
transition: border .5s, background-color .5s, transform .5s;
}

.Home_BoxBlack__bjOBn:hover {
/* background-color: #000; c1f1f7 */
box-shadow: 2px 2px 2px rgba(0, 0, 0, 1);
box-shadow: 8px 8px 8px #c1f1f7;
/* box-shadow: 0px 0px 3px 3px #000; */
/* box-shadow: 7px 7px 5px -5px #000;
box-shadow: 8px 6px 5px -5px #000; */
transform: scale(1.05);
}

/* .BoxBlack2 {
padding: 5px;
border: 2px solid #000;
} */

/* .BoxBlack3 {
box-shadow: 5px 5px 6px #c1f1f7;
transition-timing-function: ease;
transition: border .5s, background-color .5s, transform .5s;
} */

/* .BoxBlack3:hover {
box-shadow: 6px 6px 6px #c1f1f7;
-webkit-transform: scale(1.05);
-ms-transform: scale(1.05);
transform: scale(1.05);
} */

.Home_Background__I-C\\+t {
background-color: #353937;
background-color: #45494a;
background-color: #535d5f;
width: 100%; 
}

.Home_AdminBoxNew__eGc2G {
    background-color: #000;
    color: #fafafa;
    border-bottom: 1px solid #fff;
    border-top: 1px solid #fff;
}

.Home_AdminBoxNew__eGc2G:hover {
    background-color: #390236;
    background-color: #000;
}

.Home_LatestBox__Ez22A {
    background-color: #000;
    color: #fafafa;
    border-bottom: 1px solid #fff;
    border-top: 1px solid #fff;
}

.Home_LatestBox__Ez22A:hover {
    background-color: #390236;
    background-color: #000;
    color: #fafafa;
}

.Home_PrimaryBoxNew__\\+Hkxb {
    height: 50px;
    background-color: #000;
    color: #fafafa;
    border-bottom: 1px solid #fff;
}

.Home_PrimaryBoxNew__\\+Hkxb:hover {
    background-color: #390236;
    background-color: #000;
}

.Home_PrimaryBoxNew__\\+Hkxb:hover .Home_Inner2__3m-Bt {
    background-color: #042383;
}

.Home_HomeboxSmErNew__Z3Ju2 {
    background-color: #031c2d;
    background-color: #011827;
    color: #F5F5F5;
    border-bottom: 1px solid #fff;
    border-top: 1px solid #fff;
}

.Home_HomeboxSmErNew__Z3Ju2:hover {
    background-color: #390236;
    background-color: #011827;
}

.Home_Inner__JJvjt {
    background-color: #042383;
    background-color: #032896;
    height: 2px;
}

.Home_Inner2__3m-Bt {
    background-color: #780770;
    background-color: #780707;
    background-color: #780202;
    /* background-color: #03c6f1; */
    height: 3px;
}

.Home_Inner2b__p\\+qyL {
    background-color: #780770;
    background-color: #780707;
    background-color: #780202;
    /* background-color: #03c6f1; */
    height: 1px;
}

.Home_InnerD__SBmZm {
    background-color: #042383;
    background-color: #042a9b;
    background-color: #032896;
    height: 2px;
}

.Home_HomeboxFind__xxik1 {
    background-color: #869197;
    color: #fafafa;
    border-bottom: 1px solid #fff;
}

.Home_HomeboxFind__xxik1:hover {
    background-color: #390236;
}

.Home_BreakTitle__YflIQ {
  border-top: 10px solid #e8f0f1;
}

.Home_Row__FOytv {
    height: 100%;
}

.Home_Landingbox__Rj9mb {
    height: 60px;
    background-color: #3b444b;
    color: #F5F5F5;
}

.Home_Title__ApjQh {
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.6);
}
  
.Home_Image__UtUuI {
    max-width: 100%;
    object-fit: contain;
}

.Home_FillerImagel__zDyUb {
    object-fit: cover;
    height: 350px;
    width: 5px;
    margin-top: 20px;
}

.Home_FillerImageh__hFHrf {
    object-fit: cover;
    height: 90%;
    width: 100%;
    }
    

.Home_FillerImager__mgmNF {
    object-fit: cover;
    height: 300px;
    width: 50px;
    margin-top: 30px;
    background-repeat: no-repeat;
    margin: 0 auto;
}

@media screen and (max-width: 770px) {
    h5 {
        font-size: 1rem;
    }
}

@media screen and (max-width: 600px) {
    h5 {
        font-size: .75rem;
    }

    .Home_FillerImagel__zDyUb {
        width: 3px;
    } 

    .Home_AdminBox__-1Q6I {
    height: 56px;
    }

    .Home_HomeboxSmEr__fWNPj {
    height: 56px;
    }
}

/* @media screen and (max-width: 600px) {
    .Title {
        font-size: 1.12rem;
    }

    .InnerD p {
    font-size: .65rem;
    }

} */`, "",{"version":3,"sources":["webpack://./src/styles/Home.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;EACd;;AAEF;AACA,gCAAgC;AAChC,gCAAgC;AAChC,oCAAoC;AACpC,gCAAgC;AAChC,yCAAyC;AACzC,2CAA2C;AAC3C,gCAAgC;AAChC,4BAA4B;AAC5B,gCAAgC;AAChC,2DAA2D;AAC3D;;AAEA;AACA,mCAAmC;AACnC,wCAAwC;AACxC,+BAA+B;AAC/B,sCAAsC;AACtC;oCACoC;AAGpC,sBAAsB;AACtB;;AAEA;;;GAGG;;AAEH;;;;GAIG;;AAEH;;;;;GAKG;;AAEH;AACA,yBAAyB;AACzB,yBAAyB;AACzB,yBAAyB;AACzB,WAAW;AACX;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX;;;AAGJ;IACI,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,UAAU;IACd;;IAEA;IACA,YAAY;IACZ;;IAEA;IACA,YAAY;IACZ;AACJ;;AAEA;;;;;;;;;GASG","sourcesContent":[".Backgroundhome {\n    width: 100%; \n    height: 100%;\n  }\n\n.BoxBlack {\nbox-shadow: 3px 3px 1px 1px #fff;\nbox-shadow: 2px 2px 6px 2px #fff;\nbox-shadow: 7px 7px 5px -5px #c1f1f7;\nbox-shadow: 0px 0px 5px 3px #fff;\n/* box-shadow: 4px 4px 4px 4px #c1f1f7; */\n/* box-shadow: 8px 6px 5px -5px #c1f1f7;  */\nbox-shadow: 0px 0px 3px 3px #fff;\nbox-shadow: 2px 2px 6px #fff;\ntransition-timing-function: ease;\ntransition: border .5s, background-color .5s, transform .5s;\n}\n\n.BoxBlack:hover {\n/* background-color: #000; c1f1f7 */\nbox-shadow: 2px 2px 2px rgba(0, 0, 0, 1);\nbox-shadow: 8px 8px 8px #c1f1f7;\n/* box-shadow: 0px 0px 3px 3px #000; */\n/* box-shadow: 7px 7px 5px -5px #000;\nbox-shadow: 8px 6px 5px -5px #000; */\n-webkit-transform: scale(1.05);\n-ms-transform: scale(1.05);\ntransform: scale(1.05);\n}\n\n/* .BoxBlack2 {\npadding: 5px;\nborder: 2px solid #000;\n} */\n\n/* .BoxBlack3 {\nbox-shadow: 5px 5px 6px #c1f1f7;\ntransition-timing-function: ease;\ntransition: border .5s, background-color .5s, transform .5s;\n} */\n\n/* .BoxBlack3:hover {\nbox-shadow: 6px 6px 6px #c1f1f7;\n-webkit-transform: scale(1.05);\n-ms-transform: scale(1.05);\ntransform: scale(1.05);\n} */\n\n.Background {\nbackground-color: #353937;\nbackground-color: #45494a;\nbackground-color: #535d5f;\nwidth: 100%; \n}\n\n.AdminBoxNew {\n    background-color: #000;\n    color: #fafafa;\n    border-bottom: 1px solid #fff;\n    border-top: 1px solid #fff;\n}\n\n.AdminBoxNew:hover {\n    background-color: #390236;\n    background-color: #000;\n}\n\n.LatestBox {\n    background-color: #000;\n    color: #fafafa;\n    border-bottom: 1px solid #fff;\n    border-top: 1px solid #fff;\n}\n\n.LatestBox:hover {\n    background-color: #390236;\n    background-color: #000;\n    color: #fafafa;\n}\n\n.PrimaryBoxNew {\n    height: 50px;\n    background-color: #000;\n    color: #fafafa;\n    border-bottom: 1px solid #fff;\n}\n\n.PrimaryBoxNew:hover {\n    background-color: #390236;\n    background-color: #000;\n}\n\n.PrimaryBoxNew:hover .Inner2 {\n    background-color: #042383;\n}\n\n.HomeboxSmErNew {\n    background-color: #031c2d;\n    background-color: #011827;\n    color: #F5F5F5;\n    border-bottom: 1px solid #fff;\n    border-top: 1px solid #fff;\n}\n\n.HomeboxSmErNew:hover {\n    background-color: #390236;\n    background-color: #011827;\n}\n\n.Inner {\n    background-color: #042383;\n    background-color: #032896;\n    height: 2px;\n}\n\n.Inner2 {\n    background-color: #780770;\n    background-color: #780707;\n    background-color: #780202;\n    /* background-color: #03c6f1; */\n    height: 3px;\n}\n\n.Inner2b {\n    background-color: #780770;\n    background-color: #780707;\n    background-color: #780202;\n    /* background-color: #03c6f1; */\n    height: 1px;\n}\n\n.InnerD {\n    background-color: #042383;\n    background-color: #042a9b;\n    background-color: #032896;\n    height: 2px;\n}\n\n.HomeboxFind {\n    background-color: #869197;\n    color: #fafafa;\n    border-bottom: 1px solid #fff;\n}\n\n.HomeboxFind:hover {\n    background-color: #390236;\n}\n\n.BreakTitle {\n  border-top: 10px solid #e8f0f1;\n}\n\n.Row {\n    height: 100%;\n}\n\n.Landingbox {\n    height: 60px;\n    background-color: #3b444b;\n    color: #F5F5F5;\n}\n\n.Title {\n    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.6);\n}\n  \n.Image {\n    max-width: 100%;\n    object-fit: contain;\n}\n\n.FillerImagel {\n    object-fit: cover;\n    height: 350px;\n    width: 5px;\n    margin-top: 20px;\n}\n\n.FillerImageh {\n    object-fit: cover;\n    height: 90%;\n    width: 100%;\n    }\n    \n\n.FillerImager {\n    object-fit: cover;\n    height: 300px;\n    width: 50px;\n    margin-top: 30px;\n    background-repeat: no-repeat;\n    margin: 0 auto;\n}\n\n@media screen and (max-width: 770px) {\n    h5 {\n        font-size: 1rem;\n    }\n}\n\n@media screen and (max-width: 600px) {\n    h5 {\n        font-size: .75rem;\n    }\n\n    .FillerImagel {\n        width: 3px;\n    } \n\n    .AdminBox {\n    height: 56px;\n    }\n\n    .HomeboxSmEr {\n    height: 56px;\n    }\n}\n\n/* @media screen and (max-width: 600px) {\n    .Title {\n        font-size: 1.12rem;\n    }\n\n    .InnerD p {\n    font-size: .65rem;\n    }\n\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Backgroundhome": `Home_Backgroundhome__8LZQz`,
	"BoxBlack": `Home_BoxBlack__bjOBn`,
	"Background": `Home_Background__I-C+t`,
	"AdminBoxNew": `Home_AdminBoxNew__eGc2G`,
	"LatestBox": `Home_LatestBox__Ez22A`,
	"PrimaryBoxNew": `Home_PrimaryBoxNew__+Hkxb`,
	"Inner2": `Home_Inner2__3m-Bt`,
	"HomeboxSmErNew": `Home_HomeboxSmErNew__Z3Ju2`,
	"Inner": `Home_Inner__JJvjt`,
	"Inner2b": `Home_Inner2b__p+qyL`,
	"InnerD": `Home_InnerD__SBmZm`,
	"HomeboxFind": `Home_HomeboxFind__xxik1`,
	"BreakTitle": `Home_BreakTitle__YflIQ`,
	"Row": `Home_Row__FOytv`,
	"Landingbox": `Home_Landingbox__Rj9mb`,
	"Title": `Home_Title__ApjQh`,
	"Image": `Home_Image__UtUuI`,
	"FillerImagel": `Home_FillerImagel__zDyUb`,
	"FillerImageh": `Home_FillerImageh__hFHrf`,
	"FillerImager": `Home_FillerImager__mgmNF`,
	"AdminBox": `Home_AdminBox__-1Q6I`,
	"HomeboxSmEr": `Home_HomeboxSmEr__fWNPj`
};
export default ___CSS_LOADER_EXPORT___;
